export default "__VITE_ASSET__CIGkPqpl__"